<div class="govuk-grid-row">
  <div class="govuk-grid-column-three-quarters">
    <span class="govuk-caption-xl govuk-!-margin-bottom-2">{{ workplaceName }}</span>
    <h4 class="govuk-heading-l govuk-!-margin-bottom-7">10% off tailored seminars from Skills for Care</h4>
    <p>
      Delivered by Skills for Care’s expert staff from your local area, these seminars can be tailored to your needs and
      delivered directly to your organisation. There are also limited places available on group cohorts throughout the
      year. You’ll need your Workplace ID (<span
        ><strong>{{ workplaceID }}</strong></span
      >) to claim the discount. 
    </p>
    <div class="asc-cms-content" [innerHTML]="pages.content"></div>
  </div>
</div>
